// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__vpukI","consentsList":"PatientConsents_consentsList__3gXHw","consentsListEmpty":"PatientConsents_consentsListEmpty__1pOBv"};